export const init = () => {
  // Check if there is a confirm boutton
  if (cube.$('[data-target="#modal-cancel-return"]'))
    cube.$id('btn-cancel-reex').on('click', clickConfirmReturn);
};

const clickConfirmReturn = (evt) => {
  const requestId = evt.target.dataset.requestid;
  window.getAjaxHandler()
    .withCaller()
    .withUrl('rest/model/atg/commerce/custsvc/returns/ReturnsActor/removeConfirmedReturn')
    .withParameter('returnRequestId', requestId)
    .call();
};



// WEBPACK FOOTER //
// ./src/modules-es5/account/returns/returns.js